var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose } from 'class-transformer';
import { IsDateString, IsNumber, IsObject, IsString, IsUUID } from 'class-validator';
export class PreventionChapterQuizQuestionAnswerFullSizeDto {
    id;
    createdAt;
    updatedAt;
    index;
    answer;
    preventionChapterQuizQuestionId;
    preventionChapterQuizQuestion;
}
__decorate([
    Expose(),
    IsUUID(),
    __metadata("design:type", String)
], PreventionChapterQuizQuestionAnswerFullSizeDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], PreventionChapterQuizQuestionAnswerFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], PreventionChapterQuizQuestionAnswerFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], PreventionChapterQuizQuestionAnswerFullSizeDto.prototype, "index", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], PreventionChapterQuizQuestionAnswerFullSizeDto.prototype, "answer", void 0);
__decorate([
    Expose(),
    IsUUID(),
    __metadata("design:type", Object)
], PreventionChapterQuizQuestionAnswerFullSizeDto.prototype, "preventionChapterQuizQuestionId", void 0);
__decorate([
    IsObject(),
    Expose(),
    __metadata("design:type", Function)
], PreventionChapterQuizQuestionAnswerFullSizeDto.prototype, "preventionChapterQuizQuestion", void 0);
//# sourceMappingURL=prevention-chapter-quiz-question-answer.full-size.dto.js.map